// A tiny history router — the app has a handful of routes.
import { useSyncExternalStore } from 'react'

const listeners = new Set<() => void>()
const notify = () => { for (const l of listeners) l() }
window.addEventListener('popstate', notify)

export function navigate(to: string, opts: { replace?: boolean } = {}): void {
  if (opts.replace) history.replaceState(null, '', to)
  else history.pushState(null, '', to)
  notify()
  window.scrollTo(0, 0)
}

export function usePath(): string {
  return useSyncExternalStore(fn => { listeners.add(fn); return () => listeners.delete(fn) }, () => location.pathname + location.search)
}

export function match(pattern: string, path: string): Record<string, string> | null {
  const p = pattern.split('/').filter(Boolean)
  const a = path.split('?')[0].split('/').filter(Boolean)
  if (p.length !== a.length) return null
  const out: Record<string, string> = {}
  for (let i = 0; i < p.length; i++) {
    if (p[i].startsWith(':')) out[p[i].slice(1)] = decodeURIComponent(a[i])
    else if (p[i] !== a[i]) return null
  }
  return out
}

export function query(name: string): string | null {
  return new URLSearchParams(location.search).get(name)
}
